import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SET_TITLI_GAME_TIMER, SelectTitliGameTime } from '../../../redux/titli-slice/gameInfoTitliSlice'
import moment from 'moment'

function TimerControl() {
  const dispatch = useDispatch()
  const gameTimer2d = useSelector(SelectTitliGameTime)
  const [secondDiffShow, setSecondDiffShow] = useState(0)

  const getTime = (endTime) => {
    const startTime = moment()
    const secondsDiff = endTime.diff(startTime, 'seconds')

    if (secondsDiff <= 0) {
      // stop timer cleanly
      dispatch(SET_TITLI_GAME_TIMER(0))
      setSecondDiffShow(0)
      return
    }

    setSecondDiffShow(secondsDiff)
  }

  useEffect(() => {
    if (!gameTimer2d || gameTimer2d <= 0) return

    const endTime = moment().add(gameTimer2d, 'seconds')
    const interval = setInterval(() => getTime(endTime), 1000)

    return () => clearInterval(interval)
  }, [gameTimer2d])

  // Format safely
  const formattedTime =
    secondDiffShow > 0
      ? moment.utc(secondDiffShow * 1000).format('HH:mm:ss')
      : '00:00:00'

  return <>{formattedTime}</>
}

export default TimerControl
